import { getSettingOrSettingDefault } from '@disy/workbook.lib/settings';

import { getStore } from 'cadenza/store/cadenza-store';
import { CommonDataViewSettingsKey } from 'cadenza/workbook/model/common-data-view-settings-key.gen';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import { getDataViewById } from 'cadenza/workbook/workbook-core-selectors.state';

export function isAnalysisContextFilterActive(dataViewId: DataViewId) {
  return getSettingOrSettingDefault<boolean>(
    getDataViewById(getStore().getState(), dataViewId),
    CommonDataViewSettingsKey.toPersistenceKey('ANALYSIS_CONTEXT_FILTER_ACTIVE'),
  );
}
